// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bFf5","content":"styles_content__NdyVH","tableWrap":"styles_tableWrap__rPykB"};